import { config } from "../../config";

export const getMonstaPreview = async (gene: string) => {
  const res = await fetch(`${config.api.monsta}/preview`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ data: gene }),
  });
  return res;
};
